<template>
	<div>
		<div>
			<div
				v-if="drawerOpen"
				class="overlay"
				@click="drawerOpen = false; canDownloadContract = false"
			></div>
			<aside
				class="drawer"
				:class="{ open: drawerOpen }"
			>
				<div class="drawer-outer-container">
					<div class="drawer-content">
						<ProgramSummaryCard
							:clickable="false"
							:program="selectedApplication?.program"
							:program-type="selectedApplication?.program?.Code === 2 ? 'Lease Payment' : 'Loan Payment'"
							:title="!selectedApplication?.program?.leaseTermMonths ? 'Installment loan estimate' : undefined"
						/>
						<div v-if="!selectedApplication?.program?.leaseTermMonths && authUser.usr_ShowDealerCosts"
						     class="tffi-card tffi-card-summary-card">
							<div class="tffi-card-summary-card__bottom-area">
								<div class="tffi-card-summary-card__bottom-area__label">
									<p class="theming primary-color fw-bold mb-0">Dealer Cost Rate: </p>
									<span class="flex-grow-1 d-none d-lg-flex"></span>
									<p class="theming primary-color fw-bold mb-0">{{ selectedApplication?.program?.dealerCostRate | formatMoney }}%</p>
								</div>
								<div class="tffi-card-summary-card__bottom-area__label">
									<p class="theming primary-color fw-bold mb-0">Dealer Cost: </p>
									<span class="flex-grow-1 d-none d-lg-flex"></span>
									<p class="theming primary-color fw-bold mb-0">${{ selectedApplication?.program?.dealerCost | formatMoney }}</p>
								</div>
								<div class="tffi-card-summary-card__bottom-area__label">
									<p class="theming primary-color fw-bold mb-0">Dealer Admin Fee: </p>
									<span class="flex-grow-1 d-none d-lg-flex"></span>
									<p class="theming primary-color fw-bold mb-0">${{ selectedApplication?.program?.dealerAdminFee | formatMoney }}</p>
								</div>
							</div>
						</div>
						<div class="tffi-card tffi-card-summary-card">
							<div class="tffi-card-summary-card__bottom-area">
								<div class="tffi-card-summary-card__bottom-area__label">
									<p class="theming primary-color fw-bold mb-0">Applicant</p>
								</div>
								<div class="tffi-card-summary-card__bottom-area__label">
									<p class="theming fw-bold mb-0">First Name: </p>
									<span class="flex-grow-1 d-none d-lg-flex"></span>
									<p class="theming mb-0">{{ getApplicantNames(-1).firstName }}</p>
								</div>
								<div class="tffi-card-summary-card__bottom-area__label">
									<p class="theming fw-bold mb-0">Middle Initial: </p>
									<span class="flex-grow-1 d-none d-lg-flex"></span>
									<p class="theming mb-0">{{ getApplicantNames(-1).middleInitial }}</p>
								</div>
								<div class="tffi-card-summary-card__bottom-area__label">
									<p class="theming fw-bold mb-0">Last Name: </p>
									<span class="flex-grow-1 d-none d-lg-flex"></span>
									<p class="theming mb-0">{{ getApplicantNames(-1).lastName }}</p>
								</div>
								<div class="tffi-card-summary-card__bottom-area__label">
									<p class="theming fw-bold mb-0">Email: </p>
									<span class="flex-grow-1 d-none d-lg-flex"></span>
									<p class="theming mb-0">{{ selectedApplication?.email || '--' }}</p>
								</div>
								<div class="tffi-card-summary-card__bottom-area__label">
									<p class="theming fw-bold mb-0">Date of Birth: </p>
									<span class="flex-grow-1 d-none d-lg-flex"></span>
									<p class="theming mb-0">{{ selectedApplication?.dob || '--' }}</p>
								</div>
								<div class="tffi-card-summary-card__bottom-area__label">
									<p class="theming fw-bold mb-0">Address: </p>
									<span class="flex-grow-1 d-none d-lg-flex"></span>
									<p class="theming mb-0">{{ [selectedApplication?.address1, selectedApplication?.address2].filter(Boolean).join(', ') || '--' }}</p>
								</div>
								<div class="tffi-card-summary-card__bottom-area__label">
									<p class="theming fw-bold mb-0"></p>
									<span class="flex-grow-1 d-none d-lg-flex"></span>
									<p class="theming mb-0">{{ [selectedApplication?.province, selectedApplication?.postal].filter(Boolean).join(', ') || '--' }}</p>
								</div>
							</div>
						</div>
						<div v-for="(_, index) in (selectedApplication?.coApps ?? [])" :key="`${selectedApplication.id}-view-coApplicant-${index}`" >
							<div class="tffi-card tffi-card-summary-card">
								<div class="tffi-card-summary-card__bottom-area">
									<div class="tffi-card-summary-card__bottom-area__label">
										<p class="theming primary-color fw-bold mb-0">Co-applicant {{index + 1}}</p>
									</div>
									<div class="tffi-card-summary-card__bottom-area__label">
										<p class="theming fw-bold mb-0">First Name: </p>
										<span class="flex-grow-1 d-none d-lg-flex"></span>
										<p class="theming mb-0">{{ getApplicantNames(index).firstName }}</p>
									</div>
									<div class="tffi-card-summary-card__bottom-area__label">
										<p class="theming fw-bold mb-0">Middle Initial: </p>
										<span class="flex-grow-1 d-none d-lg-flex"></span>
										<p class="theming mb-0">{{ getApplicantNames(index).middleInitial }}</p>
									</div>
									<div class="tffi-card-summary-card__bottom-area__label">
										<p class="theming fw-bold mb-0">Last Name: </p>
										<span class="flex-grow-1 d-none d-lg-flex"></span>
										<p class="theming mb-0">{{ getApplicantNames(index).lastName }}</p>
									</div>
									<div class="tffi-card-summary-card__bottom-area__label">
										<p class="theming fw-bold mb-0">Email: </p>
										<span class="flex-grow-1 d-none d-lg-flex"></span>
										<p class="theming mb-0">{{ getCoEmail(index) }}</p>
									</div>
									<div class="tffi-card-summary-card__bottom-area__label">
										<p class="theming fw-bold mb-0">Date of Birth: </p>
										<span class="flex-grow-1 d-none d-lg-flex"></span>
										<p class="theming mb-0">{{ getCoDob(index) }}</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="drawer-footer d-flex justify-content-between">
						<button class="tffi-btn tffi-btn--solid theming secondary-color" @click="downloadContract" :hidden="!canDownloadContract">Contract</button>
						<div /> <!-- Required to make sure "Close" is always to the right -->
						<button class="tffi-btn tffi-btn--solid theming secondary-color" @click="drawerOpen = false">Close</button>
					</div>
				</div>
			</aside>
		</div>
		<div class="dashboard-section">

			<!-- Action Buttons -->
			<section class="dashboard-section__action-section border-radius--4px box-shadow--60px">
				<div class="container-fluid px-0">
					<div class="row">
						<div v-if="isLoanFound" class="col-12 col-sm-12 col-md-12 col-lg-6">
							<button
								class="tffi-btn tffi-btn--solid w-100 theming primary-color tffi-card__action-card dashboard-main-action-btn" @click="newLoan">
								New Loan Application
							</button>
						</div>
						<div v-if="isLeaseFound && !authUser?.udf_SuppressLeaseProgram" class="col-12 col-sm-12 col-md-12 col-lg-6">
							<button
								class="tffi-btn tffi-btn--solid w-100 theming secondary-color tffi-card__action-card dashboard-main-action-btn" @click="newLease">
								<icon name="add" type="tffi-icon" class="mr-3 font-lg" />
								New Lease Application
							</button>
						</div>

						<div v-if="isDevEnvironment" class="col-12 col-sm-12 col-md-6 col-lg-6 d-none">
							<button
								class="tffi-btn tffi-btn--solid w-100 theming warning-color tffi-card__action-card dashboard-main-action-btn"
								@click="createTestApplication">
								Create Test Application
							</button>
						</div>
					</div>
				</div>
			</section>

			<!-- Hidden Filter Section (commented out for clarity) -->
			<!--
			<section class="dashboard-section__filter-section d-none">
				<div class="container-fluid px-0">
					<div class="row d-flex align-items-center">
						<div class="col-24 col-lg-1"><h2>Filter: </h2></div>
						<div class="col-24 col-lg-5"><input type="text" class="my-0 w-100" /></div>
						<div class="col-24 col-lg-5"><input type="text" class="my-0 w-100" /></div>
						<div class="col-24 col-lg-13"><input type="text" class="ml-2 my-0 w-100" /></div>
					</div>
				</div>
			</section>
			-->

			<!-- Data Table -->
			<section class="dashboard-section__datatable-section border-radius--4px box-shadow--60px">
				<div class="container-fluid px-0">
					<div class="row">
						<div class="col-24">
							<datatable :data="databoxes" :loading="isLoading" :locale="locale" display-style="list" :order="[1, 'desc']"
							           ref="databoxes" :key="databoxKey" :issue-status-filter="issueStatusesFilter">

								<template v-slot:toolsBeforeSearch>
									<div class="dashboard-show-issues d-flex align-items-center me-1 mb-0 flex-shrink-0">
										<input
											id="dashboard-show-issues"
											v-model="showIssuesOnly"
											type="checkbox"
											class="tffi-input-checkbox theming primary-color"
										>
										<label class="mb-0 ms-2 text-nowrap" for="dashboard-show-issues">Show Issues</label>
									</div>
								</template>

								<!-- Optional Extra Action Button -->
								<router-link :to="{ name: 'leaseCalculator' }">
									<btn tag="a" color="success" size="xl">
										<i class="fa fa-calculator" style="font-size:25px;margin-right:10px;"></i>
										Lease Calculator
									</btn>
								</router-link>

								<!-- Left-side Tools -->
								<template v-slot:toolsLeft>
									<btn size="sm" color="info"
									     class="ml-3 d-none- tffi-btn tffi-btn--solid tffi-btn--bold theming primary-color" :loading="syncing"
									     :spinner-size="28" @click.native.prevent="syncApps">
										<icon name="sync" size="lg" />
									</btn>

									<span v-if="syncingMsg" class="ml-3- label- label-success-" style="margin-left: 20px;">
									Sync in progress. Please be patient and do not refresh this page.
								</span>
								</template>

								<!-- Right-side Tools -->
								<template v-slot:toolsRight>

								</template>

								<!-- Custom Status Column -->
								<template v-slot:column-status="{ item }">
								<span :class="tagClass(item)">
									{{ capitalCase(item.display) }}
								</span>
								</template>

								<!-- Actions Column -->
								<template v-slot:column-actions-column="{ item, itemKey }">
									<ul class="list-unstyled dashboard-actions-btns w-100 p-0 mb-0">
										<spinner v-if="actions[item.id] && !actions[item.id].resolved" :height="30" :width="30"
										         color="#008093" class="d-none" />

										<btn v-else v-for="(btn, btnKey) in actions[item.id].btns" :key="item.id + '-' + btnKey" type="button" :loading="spinning[itemKey + '-' + btnKey]"
										     :spinner-size="16" :spinner-absolute="true"
										     class="tffi-btn tffi-btn--solid theming primary-color dashboard-actions-btns__btn"
										     @click="confirmEventAndGo(btn, btnKey, itemKey + '-' + btnKey)" v-bind="getBtnAttrs(btn)">
											{{ getBtnLabel(btn, btnKey) }}
											<i v-if="btn.HTMLlabel" v-html="btn.HTMLlabel" />
										</btn>
									</ul>
								</template>

							</datatable>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>


<script>
import {inject} from "vue";
import Spinner from 'vue-loading-overlay/src/loaders/spinner';
import Datatable from '@/app/elements/components/Datatable';
import moment from 'moment';
import { mapState, mapActions } from 'vuex';
import { pascalCase, paramCase, capitalCase } from 'change-case';
import {
	getPrograms, getDocusealUrl, dailyApplicationsLogExport, monthlyApplicationsLogExport, saveApplication, pollEdgeStatusesForDashboard,
	getSignedUrl, search, sync
} from '@/app/api';
import { formatCurrency } from '@/app/elements/globalDirectives/CurrencyLocale';
import ProgramSummaryCard from '@/app/elements/components/ProgramSummaryCard.vue';

export default {
	setup() {
		const context = inject('applicationContext');
		return {
			context: context
		}
	},
	components: {
		Datatable,
		ProgramSummaryCard,
		Spinner,
	},

	data() {

		return {
			canDownloadContract: false,
			databoxKey: 0,
			drawerOpen: false,
			syncing: true,
			syncingMsg: false,
			isLeaseFound: false,
			isLoanFound: false,

			applications: [],

			databoxes: {
				rows: [],
				columns: [],
				searchModel: ''
			},

			actions: {},
			spinning: {},

			isLoading: true,

			errorAlert: null,
			confirmAlert: null,

			exportingDaily: false,
			exportingMonthly: false,

			showIssuesOnly: false,

			edgeStatusPollIntervalId: null,
			selectedApplication: {}
		};

	},

	filters: {
		formatMoney(value) {
			return new Intl.NumberFormat('en-US', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			}).format(value);
		},
	},

	computed: {

		...mapState({
			locale: state => state.app.locale,
			authUser: state => state.auth.authUser
		}),
		issueStatusesFilter() {
			if (!this.showIssuesOnly) {
				return null;
			}
			return [
				'More Credit Info Needed',
				'Not On Title',
				'Co-Applicant Required',
				'Approved Pending POI',
				'Approved Pending Title',
				'More Audit Info Needed'
			];
		},

		applicationFieldNames() {

			let names = [
				'id',
				'modified',
				'lastName',
				'firstName',
				// 'middleInitial',
				'fullName',
				'edgeStatus',
				'edgeId',
				'amount',
				'primaryPhone',
				'address1',
				'city',
				'dealerName',
				'actionsColumn'
			];

			if (
				['all'].includes(this.$route.params.status)
				|| !this.$route.params.status
			) {

				['firstName', 'lastName'].forEach(k => {

					let pos = names.indexOf(k);
					names.splice(pos, 1);

				});

			} else {

				let pos = names.indexOf('fullName');
				names.splice(pos, 1);

			}

			if (this.$route.params.status === 'incomplete') {

				let pos = names.indexOf('edgeId');
				names.splice(pos, 1);

				pos = names.indexOf('status');
				names.splice(pos, 1);


			}

			// let pos = names.indexOf('amount');
			// names.splice(pos, 1);

			return names;

		},

		isDevEnvironment() {
			const hostname = window.location.hostname;
			return hostname === 'localhost' ||
				hostname === 'dev.tffiapp.ca'
			//  hostname === 'staging.tffiapp.ca';
		}

	},

	watch: {

		applications: {
			handler(val) {

				// this.synchronize(val);

			},
			immediate: true
		}
	},

	created() {
		this.setName(this.$route);
		this.loadRows();
	},

	async mounted() {

		// Check for index.html updates and refresh if changed
		await this.checkForIndexHtmlUpdate();

		this.loadSearch(this.$route);

		await this.getProgramsAction()

		this.application = null

		this.edgeStatusPollIntervalId = setInterval(() => {
			this.refreshFirstPageEdgeStatusesFromServer();
		}, 10000);

	},

	beforeDestroy() {

		if (this.edgeStatusPollIntervalId != null) {
			clearInterval(this.edgeStatusPollIntervalId);
			this.edgeStatusPollIntervalId = null;
		}

		this.databoxes.columns = {};
		this.databoxes.rows = {};
		this.removeAlert(this.errorAlert);
		this.removeAlert(this.confirmAlert);

	},

	methods: {

		...mapActions([
			'saveTitle',
			'showErrorAlert',
			'removeAlert',
			'removeAlerts',
			'confirm',
			'saveLoading'
		]),
		async allowDownloadContractButton() {
			const { docuseal_submission_method, docuseal_submitters = [], edgeId, id, status, uploadTypes } = this.context.application.value?.application ?? {};
			let result = true;
			if (!["Audit Review", "Booked", "Complete", "Funded"].includes(status)) {
				const methodType = docuseal_submission_method ?? "";
				if (["embedded", "eSignature"].includes(methodType)) {
					for (const submitter of docuseal_submitters) {
						if (!['api_complete_form', 'completed'].includes(submitter.status)) {
							result = false;
							break;
						}
					}
				} else if (["onlyDealer", "print"].includes(methodType)) {
					const foundType = uploadTypes?.["0"];
					if (!foundType) {
						result = false;
					} else {
						const fileName = foundType?.documents?.[foundType?.documents?.length - 1]?.fileName;
						if (!fileName) {
							result = false;
						}
					}
				} else {
					result = false;
				}
			} else {
				const signedResult = await getSignedUrl({
					id: id,
					key: `${edgeId}-contract.pdf`
				});
				const body = JSON.parse(signedResult.body)
				const response = await fetch(body.url, {
					method: 'GET',
				});
				if (!response.ok) {
					result = false;
				}
			}
			return result;
		},
		async downloadContract() {
			this.saveLoading(true);
			let error = "No contract found."
			let result = false;
			const canDownload = await this.allowDownloadContractButton();
			if (canDownload) {
				try {
					const {docuseal_submission_method, edgeId, id, status, uploadTypes} = this.context.application.value?.application ?? {};
					if (["Audit Review", "Booked", "Complete", "Funded"].includes(status)) {
						result = await getSignedUrl({
							id: id,
							key: `${edgeId}-contract.pdf`
						});
					} else {
						const methodType = docuseal_submission_method ?? "";
						if (["embedded", "eSignature"].includes(methodType)) {
							result = await getDocusealUrl(id);
						} else if (["onlyDealer", "print"].includes(methodType)) {
							const foundType = uploadTypes?.["0"];
							const fileName = foundType?.documents?.[foundType?.documents?.length - 1]?.fileName;
							if (fileName) {
								result = await getSignedUrl({
									id: id,
									key: fileName
								});
							}
						}
					}
				} catch (error) {
					console.error(error);
					result = false;
				}
			} else {
				error = "No contract available yet."
			}
			if (result) {
				let url;
				if (result?.body) {//For s3 files
					const body = JSON.parse(result.body)
					url = body.url;
				} else {//For directly from docuseal
					url = result.url;
				}
				if (url) {
					window.open(url, '_blank');
				} else {
					result = false;
				}
			}
			if (!result) {
				this.showErrorAlert(error);
			}
			this.saveLoading(false)
		},
		newLease() {
			this.context.clearApplication();
			this.$router.push({ name: 'leaseCalculator', params: { applicationId: 'new' } });
		},
		newLoan() {
			this.context.clearApplication();
			this.$router.push({ name: 'loanCalculator', params: { applicationId: 'new' } });
		},
		/**
		 * Checks if index.html has been updated by comparing Last-Modified header
		 * with stored value. If different, refreshes the page to load new version.
		 */
		getCoDob (coApplicantIndex) { return  this.selectedApplication?.coApps?.[coApplicantIndex]?.dob ?? '--'},
		getCoEmail (coApplicantIndex) { return  this.selectedApplication?.coApps?.[coApplicantIndex]?.email ?? '--'},
		getCoFirstName (coApplicantIndex) { return  this.selectedApplication?.coApps?.[coApplicantIndex]?.firstName},
		getCoMiddleInitial (coApplicantIndex) { return  this.selectedApplication?.coApps?.[coApplicantIndex]?.middleInitial},
		getCoLastName (coApplicantIndex) { return this.selectedApplication?.coApps?.[coApplicantIndex]?.lastName} ,
		getApplicantNames (coApplicantIndex) {
			const isCoApplicant = coApplicantIndex > -1;
			let fullName = "";
			const firstName = isCoApplicant ? this.getCoFirstName(coApplicantIndex) : this.selectedApplication?.firstName;
			const middleInitial = isCoApplicant ? this.getCoMiddleInitial(coApplicantIndex) : this.selectedApplication?.middleInitial;
			const lastName = isCoApplicant ? this.getCoLastName(coApplicantIndex) : this.selectedApplication?.lastName;
			if (firstName) {
				fullName = firstName;
			}
			if (middleInitial) {
				fullName += ` ${middleInitial}`;
			}
			if (lastName) {
				fullName += ` ${lastName}`;
			}
			return { firstName: firstName, fullName: fullName, lastName: lastName, middleInitial: middleInitial };
		},
		async checkForIndexHtmlUpdate() {
			console.log("checkForIndexHtmlUpdate ==> ");
			try {
				const STORAGE_KEY = 'index_html_last_modified';
				const indexHtmlUrl = '/index.html';

				// Fetch index.html with HEAD request to get headers only
				const response = await fetch(indexHtmlUrl, {
					method: 'HEAD',
					cache: 'no-cache'
				});

				if (!response.ok) {
					console.warn('Failed to fetch index.html headers:', response.status);
					return;
				}

				// Get Last-Modified header
				const lastModified = response.headers.get('Last-Modified');
				console.log("lastModified ==> ", lastModified);

				if (!lastModified) {
					console.warn('Last-Modified header not found in index.html response');
					return;
				}

				// Get stored value from localStorage
				const storedLastModified = localStorage.getItem(STORAGE_KEY);

				if (storedLastModified) {
					// Compare with stored value
					if (storedLastModified !== lastModified) {
						// alert('index.html has been updated. Refreshing page...');
						console.log('index.html has been updated. Refreshing page...', {
							old: storedLastModified,
							new: lastModified
						});

						// Update stored value before refresh
						localStorage.setItem(STORAGE_KEY, lastModified);

						// Refresh the page to load new version
						window.location.reload();
						return;
					}
				} else {
					// First time - just store the value
					console.log('Storing initial index.html Last-Modified:', lastModified);
					localStorage.setItem(STORAGE_KEY, lastModified);
				}
			} catch (error) {
				// Silently fail - don't interrupt normal page load
				console.warn('Error checking index.html Last-Modified:', error);
			}
		},
		capitalCase: s => capitalCase(s),
		isPromise: (p) => p && Object.prototype.toString.call(p) === "[object Promise]",

		setName(to) {

			this.saveTitle(this.$i18n.t('titles.' + pascalCase('All')));

		},

		tagClass(item) {

			return 'status-tag status-tag-' + paramCase(item.value);

		},

		async confirmEventAndGo(btn, btnKey, key) {
			await this.removeAlerts();
			this.$set(this.$data, 'spinning', {});

			// If no confirmation is needed
			if (btn.confirm === false) {
				this.$set(this.spinning, key, true);

				// Call onClick if provided
				if (btn.onClick) {
					try {
						await btn.onClick();
					} catch (e) {
						console.error('Button onClick error:', e);
					} finally {
						this.$set(this.spinning, key, false);
					}
					return;
				}

				return this.$router.push(btn.to);
			}

			this.$set(this.spinning, key, true);

			let msg = this.getBtnMsg(btn, btnKey);

			this.confirmAlert = await this.confirm({
				message: msg,
				buttons: [
					{
						text: this.$i18n.t('common.yes'),
						action: async (toast) => {
							// Dismiss the confirm dialog immediately
							if (toast && toast.id) this.$snotify.remove(toast.id);
							if (btn.onClick) {
								try {
									await btn.onClick();
								} catch (e) {
									console.error('Button onClick error:', e);
								}
							} else {
								await this.$router.push(btn.to);
							}
						},
						bold: false
					},
					{
						text: this.$i18n.t('common.no'),
						action: (toast) => this.$snotify.remove(toast.id)
					}
				]
			});

			this.confirmAlert.on('hidden', () => {
				this.confirmAlert = null;
				this.$set(this.spinning, key, false);
			});
		},


		/*addParamsToLocation(params) {

			history.pushState(
				{},
				null,
				this.$route.path +
				'?' +
				Object.keys(params)
					.map(key => {
						return (
							encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
						)
					})
					.join('&')
			)

		},*/

		loadSearch(to) {

			if (to.query && to.query.q) {

				if (this.$refs.databoxes) {

					this.$set(this.$refs.databoxes, 'searchModel', to.query.q);
					this.$refs.databoxes.updateSearch(to.query.q);

				}

			}

		},

		async loadRows() {

			this.applicationFieldNames.forEach(fieldName => {

				this.databoxes.columns.push({
					label: this.$i18n.t('applications.' + fieldName),
					field: fieldName,
					sort: (fieldName === 'actionsColumn') ? false : 'asc',
					hidden: (fieldName === 'id')
				});

			});

			await this.getApplications();

		},

		async getApplications() {
			const apps = await search('All').catch(async error => {
				this.errorAlert = await this.showErrorAlert(this.$i18n.t('fatalError.fetchingContracts'));
			});
			this.$set(this.$data, 'applications', apps);
			this.isLoading = false;
			this.synchronize();
			this.syncApps();
		},

		fetch(id, arr) {

			arr = this.databoxes.rows || arr;

			return arr.find(item => (item.id === id || (item.application && item.application.id === id)));

		},

		async syncApps(event = null) {

			if (event?.preventDefault) event.preventDefault();
			// if (event) {
			// 	event.preventDefault();
			// }

			this.syncing = true;
			this.syncingMsg = true

			const syncResult = await sync();

			if (!syncResult) {
				console.log('syncResult is empty, returning');

				this.syncing = false;
				this.syncingMsg = false
				await this.refreshFirstPageEdgeStatusesFromServer();
				return
			}

			// Optional: Clear existing data
			this.databoxes.rows = []
			this.databoxes.columns = []

			// Rebuild columns
			this.applicationFieldNames.forEach(fieldName => {
				this.databoxes.columns.push({
					label: this.$i18n.t('applications.' + fieldName),
					field: fieldName,
					sort: (fieldName === 'actionsColumn') ? false : 'asc',
					hidden: (fieldName === 'id')
				});
			});

			// Fetch fresh data
			try {

				// console.log("syncResult ==> ", syncResult);

				// Trigger `synchronize()` via watcher
				this.applications = syncResult;

				await this.synchronize()

			} catch (error) {
				this.errorAlert = await this.showErrorAlert(this.$i18n.t('fatalError.fetchingContracts'));
			}

			this.syncing = false;
			this.syncingMsg = false

			await this.refreshFirstPageEdgeStatusesFromServer();

		},

		async refreshFirstPageEdgeStatusesFromServer() {
			try {
				if (this.syncing) {
					return;
				}
				await this.$nextTick();
				const dt = this.$refs.databoxes;
				if (!dt || !Array.isArray(dt.pages) || !dt.pages[0] || !dt.pages[0].length) {
					return;
				}
				const perPage = typeof dt.tools.perPage === 'number' ? dt.tools.perPage : 10;
				const rows = dt.pages[0].slice(0, perPage);
				const items = [];
				for (const row of rows) {
					const id = dt.getRowId(row);
					if (!id) {
						continue;
					}
					const appWrap = this.applications.find(a => a.application && a.application.id === id);
					const status = appWrap && appWrap.application ? appWrap.application.status : null;
					if (status == null || status === '') {
						continue;
					}
					items.push({ id, status });
				}
				if (!items.length) {
					return;
				}
				const updates = await pollEdgeStatusesForDashboard(items);
				if (!Array.isArray(updates) || !updates.length) {
					return;
				}
				for (const u of updates) {
					const appWrap = this.applications.find(a => a.application && a.application.id === u.id);
					if (appWrap && appWrap.application) {
						this.$set(appWrap.application, 'status', u.status);
						if (u.edgeStatus != null) {
							this.$set(appWrap.application, 'edgeStatus', u.edgeStatus);
						}
					}
				}
				this.synchronize();
			} catch (e) {
				console.warn('refreshFirstPageEdgeStatusesFromServer', e);
			}
		},

		async wait(time) {
			await new Promise(resolve => setTimeout(resolve, time));
		},

		synchronize() {
			console.log("synchronize() ==>");

			// Defensive: ensure we have applications
			if (!Array.isArray(this.applications)) {
				// this.databoxes.rows = [];
				console.log('returning');

				return;
			}

			// Clear current rows and rebuild
			const newRows = [];

			console.log('going through all apps');

			this.applications.forEach(item => {
				if (
					!item?.application?.id ||
					Object.keys(item).length === 0
				) {
					console.log('app empty, returning');

					return;
				}

				const app = item.application;
				const applicant = app;
				const obj = { id: app.id };

				this.applicationFieldNames.forEach(name => {
					if (name === 'fullName') {
						const fullName = `${applicant.firstName || ''} ${applicant.lastName || ''}`.trim();
						obj[name] = {
							display: fullName || '-',
							value: fullName
						};
					} else if (name === 'edgeStatus') {
						// Check if editApplicationStatus is set to show "EDIT UNDERWAY"
						const displayStatus = app.editApplicationStatus === 'Edit in Progress'
							? 'Edit Underway'
							: app.status;

						obj[name] = {
							display: displayStatus || '-',
							value: displayStatus || '-'
						};
					} else {
						const val = applicant?.[name] ?? app[name];
						obj[name] = {
							display: val ?? '-',
							value: val
						};
					}

					if (name === 'modified' && obj.modified?.value) {
						const dt = moment(obj.modified.value);
						obj.modified.value = parseInt(obj.modified.value);
						obj.modified.display = dt.format('MMM Do YYYY') + '<br /><span class="text-muted">' + dt.format('hh:mm a') + '</span>';
					}

					if (name === 'address1' && app.address2) {
						obj.address1.display = (obj.address1.display !== '-' ? obj.address1.display + '<br />' : '') + app.address2;
						obj.address1.value = (obj.address1.value || '') + ' ' + app.address2;
					}

					if (name === 'amount') {
						try {
							let val;
							if (app.programCode === '2') {
								const leaseEquipmentValue = Number(
									app.equipmentValue
									?? 0
								);
								val = parseFloat(leaseEquipmentValue.toFixed(2));
							} else {
								val = parseFloat(app.financedAmount.toFixed(2));
							}
							obj[name].value = val;
							obj[name].display = formatCurrency(val, 'en');
						} catch {
							obj[name] = { display: '-', value: 0 };
						}
					}
				});

				// if (!this.actions[app.id]) {
				this.actions[app.id] = this.getPermissionBtns(item);
				// }

				obj.actionsColumn = {
					display: null,
					value: null,
					id: app.id
				};

				newRows.push(obj);
			});

			console.log('setting new records');

			this.databoxes.rows = [...newRows];

			this.databoxKey++; // this is here so that the component updates itself

		},

		async synchronizeOld() {

			console.log("synchronize() ==> ");

			// this.databoxes.rows.length = 0

			if (!this.applications) {
				this.databoxes.rows.length = 0;
				return;
			}

			this.databoxes.rows.forEach(item => {

				let found = this.fetch(item.id, this.applications);

				if (!found) {

					// remove from results because gone
					this.databoxes.rows.splice(this.databoxes.rows.indexOf(item), 1);

				}

			});

			this.applications.forEach(item => {

				if (
					item.application
					&& !this.fetch(item.application.id)
				) {

					// add to results because new

					let obj = {
						id: item.application.id
					};

					this.applicationFieldNames.forEach(name => {

						// console.log('name', name);

						if (['fullName'].includes(name)) {

							let fullName = (item.application['firstName'] || '') + ' ' + (item.application['lastName'] || '');

							obj[name] = {
								display: fullName != ' ' ? fullName : '-',
								value: fullName
							};

						} else if (['edgeStatus'].includes(name)) {

							// Check if editApplicationStatus is set to show "EDIT UNDERWAY"
							const displayStatus = item.application.editApplicationStatus === 'Edit in Progress'
								? 'Edit Underway'
								: item.application['status'];

							obj[name] = {
								display: displayStatus,
								value: displayStatus
							};

						} else {

							obj[name] = {
								display: item.application[name] || '-',
								value: item.application[name]
							};

						}

						// if (name === 'dealerName') {
						// 	obj[name] = {
						// 		display: item.application[name] || '-',
						// 		value: item.application[name]
						// 	};
						// }

						if (name === 'modified' && obj[name] !== '-' && obj[name].value) {

							let dt = moment(obj.modified.value);
							obj.modified.value = parseInt(obj[name].value);

							obj.modified.display = dt.format('MMM Do YYYY');
							obj.modified.display += '<br /><span class="text-muted">' + dt.format('hh:mm a') + '</span>';

						} else if (name === 'address1' && item.application.address2) {

							if (obj.address1.display === '-') {

								obj.address1.display = '';
								obj.address1.value += item.application.address2;

							} else {

								obj.address1.display += '<br />';
								obj.address1.value += ' ' + item.application.address2;

							}

							obj.address1.display += item.application.address2;

						} else if (['amount'].includes(name)) {

							try {

								// console.log('item.application.program.financedAmount', item.application.program.financedAmount);

								if (item.application.programCode == '2') {
									const leaseEquipmentValue = Number(
										item.application.equipmentValue
										?? 0
									);
									obj[name].value = parseFloat(leaseEquipmentValue.toFixed(2));
									obj[name].display = formatCurrency(leaseEquipmentValue.toFixed(2), 'en');

								} else {

									obj[name].value = parseFloat(item.application.program.financedAmount.toFixed(2));
									obj[name].display = formatCurrency(item.application.program.financedAmount.toFixed(2), 'en');

								}

							} catch (error) {

							}

						}

					});

					if (!this.actions[item.application.id]) {

						this.actions[item.application.id] = this.getPermissionBtns(item);

					}

					obj.actionsColumn = {
						display: null,
						value: null,
						id: item.application.id
					};

					this.databoxes.rows.push(obj);

					// end of "add to results because new"

				}

			});

		},

		getPermissionBtns(item) {

			const id = item.application.id;
			const status = item.application.status;
			const editStatus = item.application.editApplicationStatus;
			const hasEdgeId = !!item.application.edgeId;

			const approvedStatuses = [
				'Approved',
				'Approved Pending Title',
				'Approved Conditional',
				'Approved Pending POI',
				'Ready for Fulfilment',
				'Waiting for Signature',
				'More Audit Info Needed'
			]

			const notApprovedStatuses = [
				'Incomplete',
				'More Credit Info Needed',
				'Not Approved',
				'Declined',
				'More Credit Information Required',
				'Co-Applicant Required',
				'Not On Title'
			]

			const blockedCancelStatuses = ['Incomplete', 'Complete', 'Booked', 'Funded', 'Deleted', 'Cancelled'];
			const canCancelSubmittedApplication = hasEdgeId && !blockedCancelStatuses.includes(status);

			const buildWithdrawButton = (className = 'my-1 actions__delete-btn ml-3') => ({
				color: 'info',
				label: ' ',
				HTMLlabel: '<i class="fa fa-trash"></i>',
				msg: this.$i18n.t('applications.cancelWarning'),
				to: { name: 'ApplicationEvent', params: { applicationId: id, event: 'withdraw-application' } },
				class: className,
				style: 'color:white; background-color:red; margin:0;',
				confirm: true
			});

			const viewButton = {
				color: 'info',
				label: ' ',
				HTMLlabel: '<i class="fa fa-eye"></i>',
				class: 'my-1 actions__delete-btn ml-3',
				confirm: false,
				onClick: async () => {
					try {
						let response = await this.context.getApplication(id);
						this.canDownloadContract = await this.allowDownloadContractButton();
						this.selectedApplication = response?.application ?? {};
						this.drawerOpen = true;
					} catch (err) {
						console.error(err);
					}
				}
			};

			const obj = {
				resolved: true,
				btns: {}
			};

			if (item.application.contactTffiSupport) {
				obj.btns.contactTffi = {
					color: 'info',
					label: this.$i18n.t('applications.contactTffi'),
					class: 'my-1 w-100 actions__continue-application-btn',
					confirm: false,
					disabled: true
				};
				obj.btns.view = viewButton;
				if (canCancelSubmittedApplication) {
					obj.btns.cancel = buildWithdrawButton();
				}

				this.$set(this.actions, id, obj);
				return obj;
			}

			// console.log("status ==> ", status);
			// console.log("editStatus ==> ", editStatus);

			// Handle approved statuses
			if (approvedStatuses.includes(status)) {
				// If editStatus == 'Edit in Progress', show only Edit Application button
				if (editStatus === 'Edit in Progress') {
					obj.btns.checkStatus = {
						color: 'info',
						label: 'Edit Application',
						class: 'my-1 w-100 actions__continue-application-btn',
						confirm: false,
						onClick: async () => {
							try {
								const programType = item.application.programCode === "2" ? "lease" : "loan";
								const routePath = item?.application?.firstName && item?.application?.lastName ? "Save" : "Applicants";
								await this.$router.push({ name: `${programType}${routePath}`, params: { applicationId: id } });
							} catch (err) {
								console.error(err);
							}
						}
					};
					obj.btns.view = viewButton;
					if (canCancelSubmittedApplication) {
						obj.btns.cancel = buildWithdrawButton('my-1 actions__delete-btn ml-3');
					}
				} else {
					// Show both Edit Application and Fulfilments buttons for approved statuses
					obj.btns.editApplication = {
						color: 'info',
						label: 'Edit Application',
						class: 'my-1 w-100 actions__continue-application-btn',
						confirm: true,
						msg: 'This application has already been fully or provisionally approved for credit. If you continue to edit this application, then you will need to submit the revised application for another credit approval. If you continue to edit this application, any outstanding requests for contract e-signature will be cancelled. Do you want to continue?',
						onClick: async () => {
							try {

								this.saveLoading(true);

								// Get the application
								let applicationData = await this.context.getApplication(id);
								console.log("applicationData ==> ", applicationData);

								// Set editApplicationStatus to "Edit in Progress"
								let payload = {
									id,
									editApplicationStatus: 'Edit in Progress'
								};

								// Save the application with the edit status
								await saveApplication(payload);
								// Determine if it's a lease program
								const isLease = applicationData.program?.programType === 'Lease' ||
									applicationData.program?.leaseTermMonths != null;

								// Navigate to the appropriate calculator
								const calculatorName = isLease ? 'leaseCalculator' : 'loanCalculator';
								await this.$router.push({name: calculatorName, params: {applicationId: id}});
							} catch (err) {
								console.error(err);
								this.showErrorAlert('Error editing application: ' + (err.message || 'Unknown error'));
							}
						}
					};
					obj.btns.checkStatus = {
						color: 'info',
						label: 'Fulfilment',
						class: 'my-1 w-100 actions__continue-application-btn ml-3',
						confirm: false,
						onClick: async () => {
							try {
								let response = await this.context.getApplication(id)
								const latestStatus = response.application.status;

								if (approvedStatuses.includes(latestStatus)) {
									this.$router.push({ name: 'ApplicationDashboard', params: { applicationId: id } });
								} else {
									this.showErrorAlert('This action is not available for this application.');
								}
							} catch (err) {
								console.error(err);
							}
						}
					};
					obj.btns.view = viewButton;
					if (canCancelSubmittedApplication) {
						obj.btns.cancel = buildWithdrawButton('my-1 actions__delete-btn ml-3');
					}
				}
			}
			// Handle not approved statuses
			else if (notApprovedStatuses.includes(status)) {
				obj.btns.checkStatus = {
					color: 'info',
					label: 'Edit Application',
					class: 'my-1 w-100 actions__continue-application-btn',
					confirm: false,
					onClick: async () => {
						try {
							const response = await this.context.getApplication(id);
							const latestStatus = response.application.status;
							if (notApprovedStatuses.includes(latestStatus)) {
								const programType = response.application?.program?.program?.Code === "2" ? "lease" : "loan";
								const routePath = response?.application?.firstName && response?.application?.lastName ? "Save" : "Applicants";
								await this.$router.push({ name: `${programType}${routePath}`, params: { applicationId: id } });
							} else {
								this.showErrorAlert('This action is not available for this application.');
								console.log('uncaught status', latestStatus);
							}
						} catch (err) {
							console.error(err);
						}
					}
				};

				// Add delete button for Incomplete status
				obj.btns.view = viewButton;
				if (status === 'Incomplete') {
					obj.btns.delete = {
						color: 'info',
						label: ' ',
						HTMLlabel: '<i class="fa fa-trash"></i>',
						msg: 'Are you sure you want to delete the application?',
						to: { name: 'ApplicationEvent', params: { applicationId: id, event: 'delete' } },
						class: 'my-1 actions__delete-btn ml-3',
						style: 'color:white; background-color:red',
						confirm: true
					}
				} else if (canCancelSubmittedApplication) {
					obj.btns.cancel = buildWithdrawButton('my-1 actions__delete-btn ml-3');
				}
			}
			obj.btns.view = viewButton;
			if (canCancelSubmittedApplication && !obj.btns.cancel && status !== 'Incomplete') {
				obj.btns.cancel = buildWithdrawButton('my-1 actions__delete-btn ml-3');
			}
			this.$set(this.actions, id, obj);
			return obj;
		},

		getBtnAttrs(attrs) {

			attrs = Object.assign({ size: 'sm' }, attrs);

			delete attrs.to;
			delete attrs.label;

			return attrs;

		},

		getBtnMsg(btn, btnKey) {

			if (btn.msg) {
				return btn.msg
			}

			return null

		},

		getBtnLabel(btn, btnKey) {

			if (btn.label) {

				if (typeof btn.label === 'string') {

					return btn.label;

				}

				return btn.label[this.locale];

			}

			return this.$i18n.t('applications.' + btnKey + 'Btn');

		},

		async getProgramsAction() {

			this.isLoading = true;
			this.submitting = true;

			let result = await getPrograms().catch(async error => {

				// this.saveLoading(false);

				let errorMsg = error.toString();

				if (error.response && error.response.data && error.response.data.errorMessage) {

					errorMsg = error.response.data.errorMessage;

				}

				if (errorMsg) {

					this.errorAlert = await this.showErrorAlert(errorMsg);

				}

			});

			if (result?.programs?.length == 0) {
				this.errorAlert = await this.showErrorAlert('No programs were found');
				this.saveLoading(false);
				return;
			}

			Object.keys(result?.programs ?? {}).forEach(key => {

				let program = result.programs[key];

				switch (program.Code) {
					case '2':
						this.isLeaseFound = true
						break;
					case '32':
						this.isLoanFound = true
						break;
					case '36':
						this.isLoanFound = true
						break;
					case '37':
						this.isLoanFound = true
						break;
					case '38':
						this.isLoanFound = true
						break;
					default:
						break;
				}


			});

		},

		async exportDailyLogs() {
			this.exportingDaily = true;
			try {
				const result = await dailyApplicationsLogExport();
				console.log('Daily export result:', result);
				this.$snotify.success('Daily export completed successfully');
			} catch (error) {
				console.error('Daily export error:', error);
				this.errorAlert = await this.showErrorAlert('Failed to export daily logs: ' + (error.message || 'Unknown error'));
			} finally {
				this.exportingDaily = false;
			}
		},

		async exportMonthlyLogs() {
			this.exportingMonthly = true;
			try {
				const result = await monthlyApplicationsLogExport();
				console.log('Monthly export result:', result);
				this.$snotify.success('Monthly export completed successfully');
			} catch (error) {
				console.error('Monthly export error:', error);
				this.errorAlert = await this.showErrorAlert('Failed to export monthly logs: ' + (error.message || 'Unknown error'));
			} finally {
				this.exportingMonthly = false;
			}
		},

		async createTestApplication() {
			try {
				this.isLoading = true;

				const testAppData = {
					fakeApplcation: true,
					city: "SCARBOROUGH",
					employer: "EMP",
					email: "SIVA+TEST@QALIUS.COM",
					employmentTerm: "01/01/2000",
					primaryPhone: "(416) 111-1111",
					usr_CreditReleaseObtained: "Yes",
					ip: "66.46.247.8",
					postal: "M1H 3H3",
					dob: "01/01/1990",
					address1: "68 CORPORATE DR",
					amountApproved: "0.00",
					equipmentDescription: "AIR CLEANER",
					status: "Incomplete",
					rentalAmount: "0.00",
					province: "ON",
					equipments: [
						{
							model: "MODEL",
							code: "243",
							brand: "BRAND",
							equipmentType: "AIR CLEANER"
						}
					],
					employmentTitle: "EMP TITLE",
					grossIncome: "100000",
					lastName: "TEST",
					titleOwner: "Own",
					program: {
						exactPeriodPayment: 27.77777777777778,
						fee: 0,
						intermediateAmortization: 1,
						residual: 0,
						program: {
							Description: "0.00% APR | 36 Months | 8.99% Fee NC",
							AllowUsedEquipment: "N",
							AllowRecourse: "N",
							FixedPrincipalPayments: "N",
							usr_OwnershipTerm: "120",
							usr_ProgramType: "102",
							DeferralStepPaymentTypeID: "1",
							DeferralLabel: "None",
							AllowCorpOnly: "N",
							ProgramID: "178",
							QtyZeroPayments_1: "0",
							Code: "37",
							ACHRequired: "N",
							Max_Amount: "50000",
							MinStructure: "1",
							MaxTerm: "60",
							ExcludeFromAutoPaymentCalc: "N",
							StatusID: "1",
							DeferralPeriodID: "4",
							CurrencyTypeID: "102",
							MinTerm: "60"
						},
						amortizationTerm: 36,
						frequency: "2",
						totalExactPayments: 1000,
						downPayment: null,
						dealerCostRate: 8.99,
						chargeCodeOneIsFinanced: false,
						periodRate: 0,
						chargeCodeOneAmount: 0,
						programCharges: 0,
						actualTerm: 36,
						deferralPeriod: null,
						totalObligation: 1000,
						frequencyName: "Monthly",
						intermediateTerm: 1,
						chargeCodeTwoPercent: 8.99,
						paymentTerm: "default",
						chargeCodeOnePercent: 1.5,
						financedAmount: 1000,
						invoicedAmount: 1000,
						paymentsPerYear: 12,
						standardProgramRate: 12.99,
						residualAfterTerm: -0.08000000000004093,
						periodPayment: 27.78,
						rate: 0,
						coApps: null,
						finalPayment: 27.69999999999996,
						dealerAdminFee: 0,
						chargeCodeOneWithMinMax: 0,
						term: 36,
						numberPaymentsInAmortization: 36,
						numberPaymentsInTerm: 36,
						costBorrowing: 0,
						programType: "Equal Payment",
						chargeCodeOneMax: 0,
						amount: 1000,
						amortTerm: 36,
						dealerCost: 89.9,
						chargeCodeOneBeforeMinMax: 15,
						financeTerm: 36,
						totalPayments: 1000,
						residualAfterTermOnDueDate: -0.08000000000004093,
						chargeCodeOneMin: 0,
						chargeCodeTwoAmount: 0,
						phaseOneTerm: 36,
						programId: 178,
						downpayment: 0,
						isStepLoan: false
					},
					firstName: "SIVA"
				};

				const result = await saveApplication(testAppData);
				console.log('Test application created:', result);

				this.$snotify.success('Test application created successfully');

				// Reload the applications list
				await this.getApplications();
			} catch (error) {
				console.error('Error creating test application:', error);
				this.errorAlert = await this.showErrorAlert('Failed to create test application: ' + (error.message || 'Unknown error'));
			} finally {
				this.isLoading = false;
			}
		}

	}

}

</script>

<style lang="scss" scoped>
.dashboard-show-issues {
	#dashboard-show-issues {
		margin-bottom: 15px !important;
	}
	label {
		margin-bottom: 15px !important;
	}
}

.label {
	text-transform: uppercase;
	font-weight: bold;
	font-size: 10px;
	padding: 3px 8px;
	border-radius: 10px;
	user-select: none;
	cursor: default;

	&.label-success {
		background: $success-color;
		color: #fff;
	}
}

.databoxes-length label {
	padding-top: 2px;
}

.hidden {
	opacity: 0;
	position: absolute;
	top: -1000;
	left: -1000;
	z-index: -1;
}

.databox-grid {

	.table-col-actions-column {
		height: 12rem;

		.btn {
			display: block;
			width: 100%;
			padding-left: 0.5rem;
			padding-right: 0.5rem;

			&+.btn {
				margin-top: 1rem !important;
			}
		}
	}

}

.status-tag {
	background: $light;
	border-radius: 4px;
	padding: 0.05em 0.5em;
	font-size: 12px;
	display: inline-flex;
	align-content: center;
	align-items: center;
	line-height: 1em;
	height: 2em;
	white-space: nowrap;

	&:before {
		content: "•";
		font-size: 20px;
		margin-right: 0.25em;
	}

	&.status-tag-incomplete {
		$color0: $gray-300;
		background: $color0;
		color: darken($color0, 60%);
	}

	&.status-tag-approved {
		$color1: #bff99f;
		background: $color1;
		color: darken($color1, 65%);
	}

	&.status-tag-funded {
		$color2: #b3e2ff;
		background: $color2;
		color: darken($color2, 60%);
	}

	&.status-tag-not-approved {
		$color3: #ffc4ba;
		background: $color3;
		color: darken($color3, 50%);
	}

	&.status-tag-cancelled {
		$color4: $gray-500;
		background: $color4;
		color: darken($color4, 50%);
	}

	&.status-tag-pending,
	&.status-tag-bureau-not-found {
		$color5: #fff2d1;
		background: $color5;
		color: darken($color5, 60%);
	}

	&.status-tag-submitted-to-kamsel {
		$color6: #f3ddff;
		background: $color6;
		color: darken($color6, 60%);
	}

}
// Narrower Loan # column (edgeId) - apply within child Datatable via deep selector
::v-deep .box-titles .box-cell.title-col-edge-id,
::v-deep .box-values .box-cell.values-col-edge-id,
::v-deep .box-titles .box-cell.table-col-edge-id,
::v-deep .box-values .box-cell.table-col-edge-id {
	flex: 0 0 100px !important;
	width: 100px !important;
	max-width: 100px !important;
	text-align: left;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

// Wider Actions Available column (actionsColumn)
::v-deep .box-titles .box-cell.title-col-actions-column,
::v-deep .box-values .box-cell.values-col-actions-column,
::v-deep .box-titles .box-cell.table-col-actions-column,
::v-deep .box-values .box-cell.table-col-actions-column {
	flex: 0 0 300px !important;
	width: 300px !important;
	max-width: 300px !important;
}

// List view: keep Edit / Fulfilment / trash on one row (do not use w-100 on each btn — that forces wrap)
::v-deep .databox-item.databox-list-row .box-values .box-cell.values-col-actions-column .dashboard-actions-btns,
::v-deep .databox-item.databox-list-row .box-values .box-cell.table-col-actions-column .dashboard-actions-btns {
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-items: stretch;
	justify-content: flex-start;
	gap: 0.35rem;

	> .dashboard-actions-btns__btn:not(.actions__delete-btn) {
		flex: 1 1 0;
		min-width: 0;
		width: auto !important;
		max-width: none !important;
		min-height: 50px;
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
		align-self: stretch;

		/* Global _dashboard.scss adds margin-right; gap replaces it */
		&.actions__continue-application-btn {
			margin-right: 0 !important;
		}

		/* Btn.vue wraps label in div > span; ellipsis must apply here or long labels wrap and make Edit taller than Fulfilment */
		::v-deep > div {
			min-width: 0;
			width: 100%;
			overflow: hidden;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		::v-deep span {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			display: block;
			width: 100%;
			text-align: center;
		}
	}
}

// Grid view: stack actions vertically (original card layout)
::v-deep .databox-item.databox-grid .box-values .box-cell.values-col-actions-column .dashboard-actions-btns,
::v-deep .databox-item.databox-grid .box-values .box-cell.table-col-actions-column .dashboard-actions-btns {
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	align-items: stretch;
	gap: 0.5rem;

	> .dashboard-actions-btns__btn:not(.actions__delete-btn) {
		width: 100% !important;
	}
}

// Trash (delete / cancel): fixed width; height follows row so it matches Edit / Fulfilment (no fixed 50px height)
::v-deep .box-values .box-cell.values-col-actions-column .btn.actions__delete-btn,
::v-deep .box-values .box-cell.table-col-actions-column .btn.actions__delete-btn,
::v-deep .databox-grid .table-col-actions-column .btn.actions__delete-btn {
	flex: 0 0 50px !important;
	width: 50px !important;
	min-width: 50px !important;
	max-width: 50px !important;
	min-height: 50px;
	height: auto !important;
	box-sizing: border-box !important;
	padding: 0 !important;
	display: inline-flex !important;
	align-items: center !important;
	justify-content: center !important;
	align-self: stretch !important;
	flex-shrink: 0 !important;

	.fa {
		line-height: 1;
	}
	i {
		font-size: 1.3em;
	}
}

// List only: pin trash to the right (height matches primaries via align-self: stretch above)
::v-deep .databox-item.databox-list-row .box-values .box-cell.values-col-actions-column .btn.actions__delete-btn,
::v-deep .databox-item.databox-list-row .box-values .box-cell.table-col-actions-column .btn.actions__delete-btn {
	margin-left: auto;
}

// Grid: full-width trash under primary actions
::v-deep .databox-item.databox-grid .table-col-actions-column .btn.actions__delete-btn {
	align-self: center;
	margin-left: 0;
}

// Thinner Amount column (amount)
::v-deep .box-titles .box-cell.title-col-amount,
::v-deep .box-values .box-cell.values-col-amount,
::v-deep .box-titles .box-cell.table-col-amount,
::v-deep .box-values .box-cell.table-col-amount {
	flex: 0 0 110px !important;
	width: 110px !important;
	max-width: 110px !important;
	// text-align: right;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

// Thinner modified Date column (modified)
::v-deep .box-titles .box-cell.title-col-modified,
::v-deep .box-values .box-cell.values-col-modified,
::v-deep .box-titles .box-cell.table-col-modified,
::v-deep .box-values .box-cell.table-col-modified {
	flex: 0 0 130px !important;
	width: 130px !important;
	max-width: 130px !important;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.overlay {
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 999;
}

.drawer {
	position: fixed;
	top: 0;
	right: 0;
	width: 25%;
	height: 100%;
	max-width: 90vw;
	background: white;
	box-shadow: -4px 0 12px rgba(0,0,0,.2);

	transform: translateX(100%);
	transition: transform .3s ease;

	z-index: 1001;
	padding: 20px;
	.drawer-content {
		height: 92%;
		overflow: auto;
		margin-bottom: 25px;
	}
	.drawer-footer {
		text-align: right;
	}
	.drawer-outer-container {
		height: 100%;
	}
	@media (max-width: 1240px) {
		width: 60%;
		.drawer-footer {
			font-size: 1.3em;
		}
	}
	@media (max-width: 991px) {
		width: 100%;
	}
}

.drawer.open {
	transform: translateX(0);
}
</style>
